<template>
<span>
    <v-layout mb-4>
        <v-flex xs10 ml-3>
            <h2 class="lime--text lighten-1 pt-3">Gerenciar Conteúdos - Inclusão</h2>
        </v-flex>
        <v-flex xs2 mr-3 text-right>
            <v-btn color="blue-grey" class="black--text" :to="{name: 'contents'}">
                <v-icon dark>keyboard_arrow_left</v-icon>
                Voltar
            </v-btn>
        </v-flex>
    </v-layout>

    <form-content :btnLabel="btnLabel"></form-content>
</span>
</template>

<script>
import FormContentComponent from "./partial/FormContentComponent";

export default {
    name: "AddContentComponent",
    data() {
        return {
            btnLabel: 'Incluir'
        }
    },
    methods: {

    },
    components: {
        formContent: FormContentComponent,
    }
};
</script>

<style scoped>

</style>
